import script from "./marvelExhibition.vue?vue&type=script&setup=true&lang=js"
export * from "./marvelExhibition.vue?vue&type=script&setup=true&lang=js"

import "./marvelExhibition.vue?vue&type=style&index=0&id=24fe6bea&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24fe6bea"]])

export default __exports__